export const telemetryEvents = {
  PAGE_VIEWED: 'app.page.viewed',
  SESSION_STARTED: 'session.started',
  SESSION_ENDED: 'session.ended',
  CALL_CONTROL_USED: 'call.control.used',
  CALL_PARTICIPANT_JOINED: 'call.participant.joined',
  CALL_PARTICIPANT_LEFT: 'call.participant.left',
  CALL_ROSTER_FAILED: 'call.roster.failed'
} as const

export type TelemetryEvent = (typeof telemetryEvents)[keyof typeof telemetryEvents]
